import {OmniObject} from './';

export default class OmniBounds extends OmniObject {
  className = 'Bounds';
  clickable = false;
  pixelsPerCm = false;
  fixed = false;
  centered = false;
  width = 100;
  height = 100;
  position = {x: 0, y: 0};
  fill = 0;
  relative = 0;
  ratio = 1;
  settings = {};
  /**
   * @type {function | HTMLImageElement}
   */
  cutout = null;

  cmToInch = 2.54;

  constructor(opts) {
    super();

    if (opts) {
      Object.keys(opts).forEach(i => {
        try {
          this[i] = opts[i];
          // eslint-disable-next-line
        } catch (e) {}
      });
    }
  }

  afterInit() {
    if (this.type === 'circle' && !this.cutout) {
      this.cutout = scale => {
        const path = new Path2D();
        path.arc(0.5 * scale, 0.5 * scale, 0.5 * scale, 0, 2 * Math.PI);

        return path;
      };
    }

    if (this.controller?.boundingBox) {
      if (typeof this.controller?.boundingBox.destroy === 'function') {
        this.controller?.boundingBox.destroy();
      }
    }

    this.controller?.setLayerBounds?.(this.controller?.activeLayerName, this);

    if (this.centered || this.relative) {
      this.addCenterHandler();
    }
  }

  /**
   * Increase the size of the bounds by an amount
   *
   * @param {Number} scale The amount to scale by
   * @return {void}
   */
  resize(scale) {
    this.position.x *= scale;
    this.position.y *= scale;
    this.width *= scale;
    this.height *= scale;
  }

  addCenterHandler() {
    this.onResize = this.onResize.bind(this);

    window.addEventListener('resize', this.onResize);

    this.onResize(false);
  }

  onResize(updatePositions = true) {
    const originalBounds = {
      width: this.width,
      height: this.height,
      pixelsPerCm: this.pixelsPerCm,
    };

    if (this.relative) {
      this.updateRelativeSize();
    }

    if (this.centered) {
      this.updateCenterPosition();
    }

    if (updatePositions) {
      this.controller?.repositionObjectsToBounds?.(originalBounds, this);
    }

    this.controller?.render?.();
  }

  updateRelativeSize() {
    const stage = this.controller?.params?.stage;

    const cnvAspectRatio = stage.width / stage.height;

    if (cnvAspectRatio > this.ratio) {
      // cnv is wider than template
      this.height = stage.height * this.fill;
      this.width = this.height * this.ratio;
    } else {
      // cnv is taller than template
      this.width = stage.width * this.fill;
      this.height = this.width * (1 / this.ratio);
    }
  }

  updateCenterPosition() {
    const stage = this.controller?.params?.stage;

    this.position = {
      x: stage.width / 2 - this.width / 2,
      y: stage.height / 2 - this.height / 2,
    };
  }

  destroy() {
    this.onBeforeDelete();
    window.removeEventListener('resize', this.onResize);
  }

  get dimensionsInInches() {
    if (this.pixelsPerCm) {
      return {
        x: this.width / this.pixelsPerCm / this.cmToInch,
        y: this.height / this.pixelsPerCm / this.cmToInch,
      };
    }

    return {
      x: 1,
      y: 1,
    };
  }
}
